import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RegiaoModel } from 'app/model/endereco/regiao.model';
import { RegiaoService } from 'app/service/endereco/regiao.service';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-regiao',
  templateUrl: './regiao.component.html',
  styleUrls: ['./regiao.component.scss']
})
export class RegiaoComponent implements OnInit {

  public submit = false;
  public loading = true;

  regiao = {} as RegiaoModel;
  regioes: RegiaoModel[];

  public page: ResponsePageable;

  public pageAtual = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;

  public arrayString: string;
  public creatorRegiao = false;
  public editorRegiao = false;
  public listaRegiao = false;
  public deletaRegiao = false;
  public superUser = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  @ViewChild('cardEdit') targetEl: ElementRef;
  @ViewChild('regiaoInput') regiaoInput: ElementRef;

  constructor(private regiaoService: RegiaoService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService) { }

  ngOnInit() {
    this.listPageRegioes(0, 10);
    this.getAuthority();

    this.regiaoService.emitirRegiaoCriada.subscribe(regiao =>
      console.log(regiao)
    );
  }

  listarRegioes(){
    this.regiaoService.getRegioes().subscribe(data =>{
        this.regioes = data.content;
    })
  }

  listPageRegioes(page, size){
    this.regiaoService.getPageRegioes(page, size).subscribe(res => {
      this.page = res;
      this.regioes = this.page.content;
      this.loading = false;
    })
  }

  changePage(event){
    this.listPageRegioes(event.page, event.size);
    this.pageAtual = event.page;
   }

   scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  adicionarRegiao(){
    this.regiaoService.postRegiao(this.regiao).subscribe(() =>{
      if(this.regiao.id !== undefined){
        this.regiao = new RegiaoModel();
        this.listPageRegioes(this.pageAtual, 10);
        this.openSnackBarSuccess('Região editada com sucesso !');
        this.postSubmit();
      } else {
        this.regiao = new RegiaoModel();
        this.listPageRegioes(0, 10);
        this.openSnackBarSuccess('Região salva com sucesso !');
        this.postSubmit();
      }
    }, error => {
      this.openSnackBarError('Erro !');
    })
  }

  onSubmit(){
    this.submit = true;
  }

  postSubmit(){
    this.submit = false;
    this.regiaoInput.nativeElement.value = '';
    this.regiao.descricao = null;
  }

  editarRegiao(regiao: RegiaoModel){
    this.regiao = { ...regiao}
  }

  confirmeExclusao(id: number){
    const confirme = confirm("Deseja excluir esta região ?")
    if(confirme == true){
      this.excluirRegiao(id);
    } else {
      console.log("Cancelou exclusão!");
    }
  }

  excluirRegiao(id: number){
    this.regiaoService.deleteRegiao(id).subscribe((regiao) => {
        this.regiao = new RegiaoModel();
        this.listPageRegioes(0,10);
        this.openSnackBarSuccess('Região excluída com sucesso !');
    }, error => {
      if(error.status == 500){
        this.openSnackBarError('Erro ao excluir! Esta região está sendo usado por um armazém.');
      } else {
        this.openSnackBarError('Erro ao tentar excluir a Região !');
      }
      console.log("ERROR DELETE REGIÃO: " + error.status);
    })
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorRegiao = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorRegiao = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaRegiao = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaRegiao = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

// SnackBares
openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}

}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/regiao/regiao.component.ts